/* global turf */
import { MapConstants } from '../constants/constants';

export const getCollectionBounds = (collection) => {
    if (!collection || !collection.features || !collection.features.length) {
        return MapConstants.defaultBBox;
    }
    return turf.bbox(collection);
};

export const getFocusAction = (feature) => {
    if (!feature.geometry) {
        return {};
    }
    const collection = turf.featureCollection([feature]);
    const newAction = {
        focus: true,
        collection,
    };
    if (feature.geometry.type === 'Point') {
        newAction.center = feature.geometry.coordinates;
        newAction.zoom = MapConstants.defaultPointFocusZoom;
        newAction.bearing = feature.properties.bearing;
    } else {
        newAction.bounds = getCollectionBounds(collection);
    }
    return newAction;
};
